import type { DocumentRequest, DocumentRequestItem } from '../api/types';

export const objectTypeLabels: Record<DocumentRequest['object_type'], string> = {
  APARTMENT: 'Eigentumswohnung',
  HOUSE: 'Ein- oder Zweifamilienhaus',
  MULTI_FAMILY: 'Mehrfamilienhaus',
  LAND: 'Grundstück',
  COMMERCIAL: 'Gewerbeobjekt',
};

export const sourceLabels: Record<DocumentRequestItem['source'], string> = {
  OWNER: 'Eigentümer',
  BROKER: 'Wir (Vollmacht)',
  AVAILABLE: 'liegt vor',
  SKIP: 'nicht nötig',
};

// needed: Unterlage wird noch beschafft (vom Eigentümer oder von uns).
export const needed = (it: DocumentRequestItem) => it.source === 'OWNER' || it.source === 'BROKER';

// issuerName: wer die Unterlage ausstellt (Stelle, Hausverwaltung oder Eigentümer).
export function issuerName(it: DocumentRequestItem, req: DocumentRequest): string {
  if (it.authority) return [it.authority.name, it.authority.department].filter(Boolean).join(', ');
  if (it.issuer === 'PROPERTY_MANAGER') return req.property_manager?.name ?? 'Hausverwaltung (noch nicht hinterlegt)';
  if (it.issuer === 'AUTHORITY') return req.region ? `Stelle für ${req.region} noch nicht hinterlegt` : 'Stelle noch nicht hinterlegt';
  return 'Eigentümer';
}

// recipientEmail: an wen die Anforderung per E-Mail geht (nur Stellen und Hausverwaltung).
export function recipientEmail(it: DocumentRequestItem, req: DocumentRequest): string | null {
  if (it.authority) return it.authority.email ?? null;
  if (it.issuer === 'PROPERTY_MANAGER') return req.property_manager?.email ?? null;
  return null;
}

// sendable: „wir mit Vollmacht“, noch offen und mit E-Mail-Empfänger.
export const sendable = (it: DocumentRequestItem, req: DocumentRequest) => it.source === 'BROKER' && it.status === 'OPEN' && !!recipientEmail(it, req);
